import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AccountUnderReviewModal from '../components/misc/AccountUnderReviewModal';

/**
 * Hook to check if agent account is under review (status === 0)
 * and show blocking modal if needed
 * 
 * @param {boolean} enabled - Whether to enable the status check (default: true)
 * @param {function} onGoToDashboard - Optional callback when user clicks "Go to Dashboard"
 * @returns {object} - { isBlocked, showModal, AccountStatusModal }
 */
const useAccountStatusCheck = (enabled = true, onGoToDashboard = null) => {
  const { user } = useSelector((state) => state.auth);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setShowModal(false);
      return;
    }

    // Check if user exists and status is 0 (under review)
    if (user && user.status === 0) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [user, enabled]);

  const handleGoToDashboard = () => {
    setShowModal(false);
    if (onGoToDashboard) {
      onGoToDashboard();
    }
  };

  // Component to render the modal
  const AccountStatusModal = () => (
    <AccountUnderReviewModal 
      isOpen={showModal} 
      onGoToDashboard={handleGoToDashboard}
    />
  );

  return {
    isBlocked: showModal,
    showModal,
    AccountStatusModal,
  };
};

export default useAccountStatusCheck;
